import { render, staticRenderFns } from "./TuitionStatisticsV3.vue?vue&type=template&id=79da29de&scoped=true"
import script from "./TuitionStatisticsV3.vue?vue&type=script&lang=js"
export * from "./TuitionStatisticsV3.vue?vue&type=script&lang=js"
import style0 from "./TuitionStatisticsV3.vue?vue&type=style&index=0&id=79da29de&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79da29de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79da29de')) {
      api.createRecord('79da29de', component.options)
    } else {
      api.reload('79da29de', component.options)
    }
    module.hot.accept("./TuitionStatisticsV3.vue?vue&type=template&id=79da29de&scoped=true", function () {
      api.rerender('79da29de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/component/v3/TuitionStatisticsV3.vue"
export default component.exports